import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("strong", null, "Annotator", -1)
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow" }, null, -1)

import { ElMessage } from 'element-plus';
import { storeToRefs } from 'pinia';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Logo from '@/components/Logo.vue';
import MemberAvatar from '@/components/MemberAvatar.vue';
import { canChangePassword, canCreateMember } from '@/helpers/permission';
import { useLoaderStore } from '@/stores/loader';
import { useMemberStore } from '@/stores/member';


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { t } = useI18n();
const loaderStore = useLoaderStore();
const memberStore = useMemberStore();
const { member } = storeToRefs(memberStore);

const isLoading = computed((): boolean => loaderStore.isLoading);

const logout = async (): Promise<void> => {
    if (!(await memberStore.logOut())) {
        ElMessage.error(t('common.unknownError'));
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_el_sub_menu = _resolveComponent("el-sub-menu")!
  const _component_el_menu = _resolveComponent("el-menu")!

  return (_openBlock(), _createBlock(_component_el_menu, {
    class: "header",
    mode: "horizontal",
    router: "",
    ellipsis: false,
    "background-color": "#bf9350",
    "text-color": "#fff",
    "active-text-color": "fff"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_menu_item, { index: "/" }, {
        default: _withCtx(() => [
          _createVNode(_component_router_link, { to: { name: 'litigation-list' } }, {
            default: _withCtx(() => [
              _createVNode(_component_el_icon, null, {
                default: _withCtx(() => [
                  _createVNode(Logo, {
                    alt: _unref(t)('header.home')
                  }, null, 8, ["alt"])
                ]),
                _: 1
              }),
              _createTextVNode(),
              _hoisted_1
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _hoisted_2,
      _createVNode(_component_el_sub_menu, { index: "/" }, {
        title: _withCtx(() => [
          (isLoading.value)
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "spinner",
                size: "2x",
                pulse: ""
              }))
            : _createCommentVNode("", true),
          _createTextVNode("  "),
          (_unref(member))
            ? (_openBlock(), _createBlock(MemberAvatar, {
                key: 1,
                member: _unref(member),
                "disable-role-expansion": "",
                "disable-click-events": ""
              }, null, 8, ["member"]))
            : _createCommentVNode("", true)
        ]),
        default: _withCtx(() => [
          (_unref(canCreateMember)())
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 0,
                index: "/members"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('header.administration')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (_unref(canChangePassword)())
            ? (_openBlock(), _createBlock(_component_el_menu_item, {
                key: 1,
                index: "/reset-password"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('header.changePassword')), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_menu_item, {
            index: "",
            onClick: logout
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('header.logout')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})